import { useEffect, useState } from "react";
import PathHelper from "../../../utils/path-helper";
import { APP_NAVIGATION } from "../../../utils/constants";
import { currentDomain } from "../../../utils/general-config";
import { getPdfSimpliBaseURL, getResumeBuildBaseURL } from "../../../services/api-constants";
import { DomainEnum } from "../../../services/enum/environment-enum";
import { readCookie } from "../../../utils/helpers";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Logo = () => {
  const [isLogoDisabled, setIsLogoDisabled] = useState();

  let pathRedirect = PathHelper(APP_NAVIGATION.HOME);
  const domain = currentDomain();
  useEffect(() => {
    if (window.location.href.includes("/plans") || window.location.href.includes("/checkout")) {
      setIsLogoDisabled(true);
    }
  }, []);
  const handleClick = (event) => {
    return getResumeBuildBaseURL;
  };
  return (
    <a
      href={pathRedirect.cstm}
      onClick={handleClick}
      className={classNames(
        isLogoDisabled ? "cursor-auto" : "cursor-pointer",
        `inline-block pt-[7px] pb-[0px] sm:py-[5px] mr-4 lg:-mt-[4px] text-xl whitespace-nowrap`
      )}
    >
      {domain === DomainEnum.PDFSIMPLI ? (
        <img
          className="pdf-simpli-logo lg:ml-1.5 w-36 sm:w-40 lg:w-44 h-7 sm:h-9 lg:h-10 pr-1 lg:pr-0"
          src={process.env.PUBLIC_URL + "/static/images/logos/pdfsimpli-new-logo.svg"}
          width="180"
          alt="Logo"
        />
      ) : domain === DomainEnum.SIGNSIMPLI ? (
        <img
          className="pdf-simpli-logo lg:ml-1.5 w-36 sm:w-40 lg:w-44 h-7 sm:h-9 lg:h-10 pr-1 lg:pr-0"
          src={process.env.PUBLIC_URL + "/static/images/logos/signsimpli-new-logo.svg"}
          width="180"
          alt="Logo"
        />
      ) : (
        <img
          className={`rb-logo ${domain === DomainEnum.WORKSIMPLI ? "w-52" : ""} `}
          src={process.env.PUBLIC_URL + "/static/images/logos/" + domain.toLowerCase() + "-logo.svg"}
          width="117"
          alt="Logo"
        />
      )}
    </a>
  );
};

export default Logo;
